import { StartPageList, type StartPageListProps } from '../start-page-list/StartPageList';
import type { FrontpageResponse } from '../../types';

import styles from './start-page.module.css';

export type StartPageProps = {
    results: FrontpageResponse;
};

const lists = [
    { type: 'Programmes', facetKey: 'programmes' },
    { type: 'Articles', facetKey: 'articles' },
    { type: 'Employees', facetKey: 'employees' },
    { type: 'Events', facetKey: 'events' },
] as { type: StartPageListProps['type']; facetKey: keyof Omit<FrontpageResponse, 'facets'> }[];

export const StartPage = ({ results }: StartPageProps) => {
    // Sort lists by highest scoring result in each category
    const sorted = [...lists].sort(
        (a, b) => (results[b.facetKey][0]?.score ?? -Infinity) - (results[a.facetKey][0]?.score ?? -Infinity),
    );

    return (
        <div className={styles.startPageLists}>
            {sorted.map(({ type, facetKey }) => (
                <StartPageList key={type} type={type} count={results.facets[facetKey]} results={results[facetKey]} />
            ))}
        </div>
    );
};
